/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Method_Change_UntraceableInputs */

const vi_error_payment_method_change_untraceable = /** @type {(inputs: Error_Payment_Method_Change_UntraceableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy đúng một dòng sổ công nợ của khoản này (thường là khoản ghi từ trước khi có sổ công nợ) nên không đổi được. Hãy báo quản trị để kiểm tra.`)
};

/**

* @param {Error_Payment_Method_Change_UntraceableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_payment_method_change_untraceable = /** @type {((inputs?: Error_Payment_Method_Change_UntraceableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Method_Change_UntraceableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_payment_method_change_untraceable(inputs)
});